import {Injectable, Injector} from "@angular/core";
import {ReportModel} from "@fedeltapointofsale/data-client";
import {ProductPluReportData} from "./product-plu-report.data";

@Injectable()
export class ProductPluReportModel extends ReportModel<ProductPluReportData> {
    constructor(injector: Injector) {
        super(injector, ProductPluReportData);
    }
}
